module.exports = __webpack_public_path__ + "static/media/rupee-indian.6728e613.svg";